import React, { Component } from "react";
import { connect } from "react-redux";
import "./index.less";
import MyHeader from "./header";
import MyContent from "./content";
import MyRightSider from "./rightSider";
import MyLeftSider from "./leftSider";
import { Steps } from "antd";
import { GetQuery, langCheck } from "Pub/js/utils";
import { getMulti } from 'Pub/js/getMulti';
import { queryAllArea, queryTemplateProperty } from './events';
import { setZoneDataFun, updateAreaList, setImplementFlag, setServerData, setMobileFlag, setReportFlag } from "Store/ZoneSetting/action";
import { setZoneData, setZoneTempletid, setJson } from 'Store/Zone/action';
import platform from "Pub/js/platform";
import Ajax from 'Pub/js/ajax';
const Step = Steps.Step;
const DragWithCom = platform.DragWithCom;

//模板配置首页
class ZoneSetting extends Component {
    constructor(props) {
        super(props);
        this.urlRequestObj = GetQuery(this.props.location.search);
        this.state = {
            templetid: this.urlRequestObj.templetid,
            status: this.urlRequestObj.status, // status
            pcode: this.urlRequestObj.pcode,
            appcode: this.urlRequestObj.appcode,
            json: {},
            isLang: false,
            isImplement: this.urlRequestObj.status === 'templateSetting' || this.urlRequestObj.status === 'templateSetting-unit', //实施态
            ismobile: this.urlRequestObj.templettype === "mobile", //移动模板
            isreport: this.urlRequestObj.isreport === "true", //报表模板
            ts: null, //ts给保存接口使用
            multiOptions: []
        };
    }
    componentWillMount() {
        let callback = (json) => {
            // console.log('json', json);
            window.multiZoneSettingLang = json;
            this.props.setJson(json);
            this.queryLanguage(json, (multiOptions) => {
                this.setState({
                    json: json,
                    isLang: true,
                    multiOptions
                });
            });
        };
        getMulti({
            moduleId: ['ZoneSetting', '102202APP'],
            // currentLocale: 'zh-CN',
            domainName: 'workbench',
            callback
        });
        this.props.setImplementFlag(this.state.isImplement);
        this.props.setMobileFlag(this.state.ismobile);
        this.props.setReportFlag(this.state.isreport);
    }
    //多语
    componentDidMount() {
        let param = GetQuery(this.props.location.search);
        this.props.setZoneTempletid(param.templetid);
        //请求完模板数据后在请求字段
        queryAllArea.call(this).then((data) => {
            this.setState({ ts: data.ts }); //ts给保存接口使用
            queryTemplateProperty.call(this);
        });
    }
    queryLanguage = (langMultiData, callback) => {
        Ajax({
            url: '/nccloud/platform/appregister/querylanguagevos.do',
            info: {
                action: langCheck(
                    "ZoneSetting-000351",
                    true,
                    langMultiData
                ) /* 国际化处理： 查询启用语种*/,
                name: langCheck(
                    "ZoneSetting-000044",
                    true,
                    langMultiData
                ) /* 国际化处理： 应用注册*/,
            },
            success: ({ data: { data } }) => {
                if (data && data.length > 0) {
                    /**
                     * 前端组合成多语文本可以支持的options
                     */
                    let multiOptions = data.map((item, index) => {
                        let itemIndex = ++index;
                        let multiItem = {
                            index: "",
                            languageType: "zh",
                            languageCode: "simpchn",
                        };
                        multiItem.index = itemIndex > 1 ? multiItem.index + itemIndex : "";
                        multiItem.languageType = item.locallang;
                        multiItem.languageCode = item.langcode;
                        multiItem.languageMain = item.langseq == "1" ? true : false;
                        return multiItem;
                    });
                    callback(multiOptions);
                }
            }
        });
    }

    render() {
        let { json, isImplement } = this.state;
        const { leftSiderShow } = this.props;
        //实时态，status控制steps是否显示
        // let show = this.urlRequestObj.status
        //     ? "display_none"
        //     : "template-setting-steps";
        return (
            <div className="template-setting-page">
                {/* <div className={show}>
                    <Steps size="small" current={1}>
                        <Step title={langCheck('ZoneSetting-000052', 'pages', json)} description={langCheck('ZoneSetting-000053', 'pages', json)} />
                        <Step title={langCheck('ZoneSetting-000035', 'pages', json)} description={langCheck('ZoneSetting-000054', 'pages', json)} />
                        <Step title={langCheck('ZoneSetting-000055', 'pages', json)} description="" />
                    </Steps>
                </div> */}
                <MyHeader
                    templetid={this.state.templetid}
                    status={this.state.status}
                    pcode={this.state.pcode}
                    appcode={this.state.appcode}
                    json={this.state.json}
                    ts={this.state.ts}
                    multiOptions={this.state.multiOptions}
                    hideBackBtn={this.props.hideBackBtn}
                />
                <div className={`template-setting-container ${leftSiderShow ? '' : 'hide-drag-line'}`}>
                    {
                        isImplement
                            ? (<DragWithCom
                                defLeftWid={leftSiderShow ? '279px' : '0px'}
                                leftMinWid={leftSiderShow ? '279px' : '0px'}
                                leftDom={<MyLeftSider
                                    json={this.state.json}
                                    status={this.state.status}
                                    show={leftSiderShow}
                                    multiOptions={this.state.multiOptions}
                                />}
                                rightDom={<React.Fragment>
                                    <MyContent
                                        templetid={this.state.templetid}
                                        status={this.state.status}
                                        json={this.state.json}
                                        multiOptions={this.state.multiOptions}
                                    />
                                    {
                                        this.state.isLang ?
                                            <MyRightSider
                                                json={this.state.json}
                                                status={this.state.status}
                                                multiOptions={this.state.multiOptions}
                                            />
                                            : null
                                    }
                                </React.Fragment>}
                            />)
                            : (
                                <React.Fragment>
                                    <MyLeftSider
                                        json={this.state.json}
                                        status={this.state.status}
                                        show={leftSiderShow}
                                        templettype={GetQuery(this.props.location.search) && GetQuery(this.props.location.search).templettype}
                                        multiOptions={this.state.multiOptions}
                                    />

                                    <MyContent
                                        templetid={this.state.templetid}
                                        status={this.state.status}
                                        json={this.state.json}
                                        pcode={this.state.pcode}
                                        appcode={this.state.appcode}
                                        multiOptions={this.state.multiOptions}
                                    />
                                    {
                                        this.state.isLang ?
                                            <MyRightSider
                                                multiOptions={this.state.multiOptions}
                                                json={this.state.json}
                                                status={this.state.status}
                                            />
                                            : null
                                    }
                                </React.Fragment>
                            )
                    }


                </div>
            </div>
        );
    }
}
export default connect(
    state => ({
        isImplement: state.zoneSettingData.isImplement,
        leftSiderShow: state.zoneSettingData.leftSiderShow
    }),
    {
        setJson,
        setZoneData,
        setZoneTempletid,
        setZoneDataFun,
        updateAreaList,
        setImplementFlag,
        setServerData,
        setMobileFlag,
        setReportFlag,
    }
)(ZoneSetting);
